export default "__VITE_ASSET__uUaaAeSm__"